import { ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";

import HNSColors from "../../../components/ui library/HNSColors";

export default function SideBarMenuItem({
  icon,
  sideBarIsOpen,
  setSideBarIsOpen,
  Menu,
  isActiveURL,
  triggerDropdown,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { handlerFn, url, title } = Menu;

  return (
    <div className="mb-1 w-full rounded-md">
      <Tooltip title={title} placement="right" disableHoverListener={sideBarIsOpen || isActiveURL}>
        <ListItemButton
          onClick={() => {
            const targetUrl = handlerFn ? `${location.pathname}${location.search}` : url;
            triggerDropdown();
            handlerFn?.();
            navigate(targetUrl);
            setSideBarIsOpen(false);
          }}
          sx={{
            marginLeft: 1.5,
            marginRight: 1.0,
            borderRadius: 1.2,
            marginBottom: 1,
            py: 0.7,
            minHeight: 42,
            backgroundColor: isActiveURL ? HNSColors.tertiary[900] : "transparent",
            pl: sideBarIsOpen ? 0.5 : 1,
            justifyContent: sideBarIsOpen ? "flex-start" : "center",
            borderLeft:
              isActiveURL && sideBarIsOpen
                ? `4px solid ${HNSColors.tertiary[400]}`
                : "4px solid transparent",
          }}
        >
          {isActiveURL && !sideBarIsOpen && (
            <span
              style={{
                width: "5px",
                backgroundColor: HNSColors.tertiary[400],
                borderRadius: "15px",
                position: "absolute",
                height: "36px",
                top: "3px",
                left: "-13px",
              }}
            />
          )}
          <ListItemIcon sx={{ minWidth: 32, justifyContent: "center" }}>{icon}</ListItemIcon>
          {sideBarIsOpen && (
            <ListItemText
              primary={title}
              sx={{
                ml: 1,
                span: { fontSize: 14, fontWeight: 600 },
                color: isActiveURL ? HNSColors.primary[600] : HNSColors.neutrals[300],
              }}
            />
          )}
        </ListItemButton>
      </Tooltip>
    </div>
  );
}
